<template>
    <div class="common-bg">
        <div class="tool-drawer-header">
            <a-icon type="left" v-if="isBack" @click="backGo"/>
            <div class="title">{{title}}</div>
        </div>

        <div class="tool-drawer-content" :class="!buttonShow?'nobottom':''">
            <slot></slot>
        </div>

        <div class="tool-drawer-btns" v-if="buttonShow">
            <slot name="bottom"></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "EditDrawer",
        props:{
            isBack:{
                type:Boolean,
                default: false
            },
            title:{
                type:String,
                default:''
            },
            buttonShow:{
                type:Boolean,
                default: true
            }
        },
        methods:{
            backGo(){
                this.$emit('goBack')
            }
        }
    }
</script>

<style lang="less" scoped>
    .common-bg {
        font-size: 14px;
        height: 100%;
        .tool-drawer-header {
            color: #e6e6e6;
            display: flex;
            align-items: center;
            position: relative;
            padding: 0 16px;
            height: 44px;
            border-bottom: 2px solid #000000;
            justify-content: flex-start;
            /deep/ .anticon{
                margin-right: 6px;
            }
        }
        .tool-drawer-content{
            height: calc(100% - 44px - 96px);
            padding-top: 20px;
            overflow-y: auto;
            &.nobottom{
                height: calc(100% - 44px);
            }
            &::-webkit-scrollbar {
                width: 6px;
                height: 6px;
                /**/
            }
            &::-webkit-scrollbar-track {
                background: #141414;
                border-radius: 2px;
                box-shadow: none;
            }
            &::-webkit-scrollbar-thumb {
                background: #323232;
                border-radius: 3px;
            }
            &::-webkit-scrollbar-thumb:hover {
                background: #323232;
            }
        }
        .tool-drawer-btns{
            border-top: 1px solid #000000;
            display: flex;
            padding: 0 12px;
            align-items: center;
            justify-content: space-between;
            height: 96px;
        }
    }
</style>
